import { Injectable, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import {
  AuthAccessTokenDetails,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  SwapAuthForAccessTokens
} from '../../models/login';
import { LoginAuthorizationService } from '../../services/login/data-services/login-authorization/login-authorization-service';
import { LoginPostWithFingerPrintService } from '../../services/login/data-services/login-post-with-fingerprint/login-post-with-fingerprint-service';
import { SwapAccessTokenService } from '../../services/login/data-services/swap-access-token/swap-access-token-service';
import {
  isUserNamePasswordRequired,
  returnTransformTokenDetails
} from '../../utils/login/initiate-login-utils';
import { LoginRememberMeErrorUtilService } from '../../utils/login/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../../utils/login/login-remember-me-utils.service';
import { PostWithCredentialsFacadeService } from './post-with-credentials-facade.service';

@Injectable({
  providedIn: 'root'
})
export class InitiateLoginFacadeHelperService {
  retryCount = 0;

  loginAuthorization = inject(LoginAuthorizationService);
  loginPostWithFingerPrint = inject(LoginPostWithFingerPrintService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  postWithCredentialsFacade = inject(PostWithCredentialsFacadeService);
  loginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);

  processResponse(
    response:
      | LoginAuthWithCredentialsResponse
      | SwapAuthForAccessTokens
      | AuthAccessTokenDetails
      | string
      | boolean,
    loginOAuthParams: LoginOAuthParams,
    appToken = false
  ): Observable<boolean | AuthAccessTokenDetails | never> {
    if (typeof response === 'boolean') {
      return of(response);
    } else if (typeof response === 'string') {
      return throwError(response);
    } else {
      return this.processResponseHelper(response, loginOAuthParams, appToken);
    }
  }

  processResponseHelper(
    response:
      | LoginAuthWithCredentialsResponse
      | SwapAuthForAccessTokens
      | AuthAccessTokenDetails,
    loginOAuthParams: LoginOAuthParams,
    appToken = false
  ): Observable<boolean | AuthAccessTokenDetails | never> {
    if (isUserNamePasswordRequired(response, loginOAuthParams)) {
      this.retryCount = 0;
      return of(true);
    } else if ('access_token' in response) {
      if (!appToken) {
        this.loginRememberMeUtils.sendTokenServiceWorker(
          loginOAuthParams.oauthConfig,
          response
        );
      }
      this.retryCount = 0;
      return returnTransformTokenDetails(
        response,
        this.postWithCredentialsFacade
      );
    } else {
      return throwError(response);
    }
  }
}
